module.exports = "<style>\n  .mat-raised-button {\n    border-radius: 9px;\n  }\n</style>\n<div class=\"container\">\n\n\n  <div id=\"widget\" style=\"padding-top: 20px\">\n\n  </div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widget-page/widget-page.component.html
// module id = 923
// module chunks = 3